export const Types = {
  REQUEST: '@login/REQUEST',
  FAILURE: '@login/FAILURE',
};

interface ILoginPayload {
  payload: {
    email: string;
    password: string;
  };
}

interface ILoginRequestReturn {
  type: string;
  payload: Object;
  meta: Object;
}

interface ILoginFailureReturn {
  type: string;
  error: Object;
}

export function loginRequest(
  payload: ILoginPayload,
  onSuccess: Function,
  onFailure: Function,
): ILoginRequestReturn {
  return {
    type: Types.REQUEST,
    payload,
    meta: { onSuccess, onFailure },
  };
}

export function loginFailure(error: Object): ILoginFailureReturn {
  return {
    type: Types.FAILURE,
    error,
  };
}
